import React, { useMemo } from 'react'
import moment, { Moment } from 'moment'
import { DateField } from '@/ui/form/controls/DateField'

import { useBusinessTripRatesTableContext } from '../context/BusinessTripRatesTableContext'

import { useBusinessTripRatesRowContext } from '../context/BusinessTripRatesRowContext'

export const dateIsDirty = (
  saved?: Moment | Date | null,
  current?: Moment | Date | null,
): boolean => {
  if (!saved && !current) return false
  if (!saved && current) return true
  if (saved && !current) return true

  const savedDate = moment(saved)
  const currentDate = moment(current)

  if (!savedDate.isValid() && !currentDate.isValid()) return false
  if (!savedDate.isValid() || !currentDate.isValid()) return true

  return !savedDate.isSame(currentDate, 'day')
}

function _parseDate(start: string | Date | Moment) {
  if (typeof start === 'string') {
    return new Date(start)
  }
  return start
}
function _dateIsDirty(
  start: string | Date | Moment | null | undefined,
  end: string | Date | Moment | null | undefined,
) {
  if (start === end) return false
  if (Boolean(start) === false && Boolean(end) === false) return false
  if((Boolean(start) === false && Boolean(end) === true) || (Boolean(start) === true && Boolean(end) === false)){
    return true
  }
  if (Boolean(start) && Boolean(end)) {
    return dateIsDirty(_parseDate(start), _parseDate(end))
  }
  return false
}

export const DateInput = ({ name }: { name: 'dateFrom' | 'dateTo' }) => {
  const {
    savedRates,
    availableCountries,
    availableCurrencies,
    handleUpdate,
    handleDelete,
  } = useBusinessTripRatesTableContext()
  const { rate } = useBusinessTripRatesRowContext()
  const savedRow = useMemo(
    () => savedRates.find((sr) => sr.id === rate.id),
    [savedRates, rate.id],
  )

  const value =
    rate[name] != null ? moment(rate[name]).format('YYYY-MM-DD') : null

  const isDirty =
    !savedRow || _dateIsDirty(savedRow && savedRow[name], rate && rate[name])

  const setValue = (date: string) => {
    if (_dateIsDirty(date, value)) {
      handleUpdate(rate.id, { [name]: date ? moment(date) : null })
    }
  }

  return (
    <DateField
      value={value}
      setValue={setValue}
      className={isDirty ? 'tw-text-red-400' : ''}
    />
  )
}
